import ForecastWeatherWidget from "./ForecastWeatherWidget";

export default ForecastWeatherWidget;